// teeth images by numbers
import tooth11Src from '@/assets/images/teeth/prosthetic-scheme/11.svg'
import tooth12Src from '@/assets/images/teeth/prosthetic-scheme/12.svg'
import tooth13Src from '@/assets/images/teeth/prosthetic-scheme/13.svg'
import tooth14Src from '@/assets/images/teeth/prosthetic-scheme/14.svg'
import tooth15Src from '@/assets/images/teeth/prosthetic-scheme/15.svg'
import tooth16Src from '@/assets/images/teeth/prosthetic-scheme/16.svg'
import tooth17Src from '@/assets/images/teeth/prosthetic-scheme/17.svg'
import tooth18Src from '@/assets/images/teeth/prosthetic-scheme/18.svg'
import tooth21Src from '@/assets/images/teeth/prosthetic-scheme/21.svg'
import tooth22Src from '@/assets/images/teeth/prosthetic-scheme/22.svg'
import tooth23Src from '@/assets/images/teeth/prosthetic-scheme/23.svg'
import tooth24Src from '@/assets/images/teeth/prosthetic-scheme/24.svg'
import tooth25Src from '@/assets/images/teeth/prosthetic-scheme/25.svg'
import tooth26Src from '@/assets/images/teeth/prosthetic-scheme/26.svg'
import tooth27Src from '@/assets/images/teeth/prosthetic-scheme/27.svg'
import tooth28Src from '@/assets/images/teeth/prosthetic-scheme/28.svg'
import tooth31Src from '@/assets/images/teeth/prosthetic-scheme/31.svg'
import tooth32Src from '@/assets/images/teeth/prosthetic-scheme/32.svg'
import tooth33Src from '@/assets/images/teeth/prosthetic-scheme/33.svg'
import tooth34Src from '@/assets/images/teeth/prosthetic-scheme/34.svg'
import tooth35Src from '@/assets/images/teeth/prosthetic-scheme/35.svg'
import tooth36Src from '@/assets/images/teeth/prosthetic-scheme/36.svg'
import tooth37Src from '@/assets/images/teeth/prosthetic-scheme/37.svg'
import tooth38Src from '@/assets/images/teeth/prosthetic-scheme/38.svg'
import tooth41Src from '@/assets/images/teeth/prosthetic-scheme/41.svg'
import tooth42Src from '@/assets/images/teeth/prosthetic-scheme/42.svg'
import tooth43Src from '@/assets/images/teeth/prosthetic-scheme/43.svg'
import tooth44Src from '@/assets/images/teeth/prosthetic-scheme/44.svg'
import tooth45Src from '@/assets/images/teeth/prosthetic-scheme/45.svg'
import tooth46Src from '@/assets/images/teeth/prosthetic-scheme/46.svg'
import tooth47Src from '@/assets/images/teeth/prosthetic-scheme/47.svg'
import tooth48Src from '@/assets/images/teeth/prosthetic-scheme/48.svg'

// teeth states images
import alignerSrc from '@/assets/images/teeth/state/aligner.svg'
import augmentationSrc from '@/assets/images/teeth/state/augmentation.svg'
import braceSrc from '@/assets/images/teeth/state/brace.svg'
import byugelnyCrownSrc from '@/assets/images/teeth/state/byugelny-crown.svg'
import crownBmToothSrc from '@/assets/images/teeth/state/crown-bm-tooth.svg'
import crownImplantSrc from '@/assets/images/teeth/state/crown-implant.svg'
import crownMkToothSrc from '@/assets/images/teeth/state/crown-mk-tooth.svg'
import implantSrc from '@/assets/images/teeth/state/implant.svg'
import intermediateCrownSrc from '@/assets/images/teeth/state/intermediate-crown.svg'
import sealSrc from '@/assets/images/teeth/state/seal.svg'
import sinusliftSrc from '@/assets/images/teeth/state/sinuslift.svg'
import treatedCanalsToothSrc from '@/assets/images/teeth/state/treated-canals-tooth.svg'
import veneerSrc from '@/assets/images/teeth/state/veneer.svg'
import { computed } from 'vue'
import store from '@/store'

export default function useTeeth() {
  const teethRowNumbers = computed(() => store.getters['patient/getRowNumbers'])
  const formattedTeethList = teeth => {
    let result = []
    let data = {}
    let prevNumber = null
    let allTeethNumbers = []
    teeth.map(i => allTeethNumbers.push(i))
    allTeethNumbers.sort()
    allTeethNumbers.map(i => {
      if (prevNumber && prevNumber in data) {
        if (prevNumber + data[prevNumber] === i) {
          data[prevNumber] += 1
        } else {
          data[i] = 1
          prevNumber = i
        }
      } else {
        data[i] = 1
        prevNumber = i
      }
    })
    Object.keys(data).map(key => {
      key = parseInt(key)
      if (data[key] > 1) {
        if (data[key] === 2) {
          result.push(key, key + 1)
        } else {
          result.push(`${key}-${key + data[key] - 1}`)
        }
      } else {
        result.push(key)
      }
    })
    return result
  }
  const teethImages = {
    11: tooth11Src, 12: tooth12Src, 13: tooth13Src, 14: tooth14Src, 15: tooth15Src, 16: tooth16Src, 17: tooth17Src,
    18: tooth18Src, 21: tooth21Src, 22: tooth22Src, 23: tooth23Src, 24: tooth24Src, 25: tooth25Src, 26: tooth26Src,
    27: tooth27Src, 28: tooth28Src, 31: tooth31Src, 32: tooth32Src, 33: tooth33Src, 34: tooth34Src, 35: tooth35Src,
    36: tooth36Src, 37: tooth37Src, 38: tooth38Src, 41: tooth41Src, 42: tooth42Src, 43: tooth43Src, 44: tooth44Src,
    45: tooth45Src, 46: tooth46Src, 47: tooth47Src, 48: tooth48Src
  }
  const teethStateImages = {
    aligner: alignerSrc, augmentation: augmentationSrc, brace: braceSrc, 'byugelny-crown': byugelnyCrownSrc,
    'crown-bm-tooth': crownBmToothSrc, 'crown-implant': crownImplantSrc, 'crown-mk-tooth': crownMkToothSrc,
    implant: implantSrc, 'intermediate-crown': intermediateCrownSrc, seal: sealSrc, sinuslift: sinusliftSrc,
    'treated-canals-tooth': treatedCanalsToothSrc, veneer: veneerSrc
  }
  const getToothImageSrc = toothNumber => toothNumber in teethImages ? teethImages[toothNumber] : null
  const getToothStateImageSrc = toothNumber => toothNumber in teethStateImages ? teethStateImages[toothNumber] : null

  return {
    teethRowNumbers,

    formattedTeethList,
    getToothImageSrc,
    getToothStateImageSrc
  }
}